// INFO
// Функция по имени получает значение CSS переменной
// и возвращает это значение
module.exports = getVarCSS = (cssProperty) => {
    const root = document.querySelector('html:root')
    const rootStyles = getComputedStyle(root)
    return  rootStyles.getPropertyValue(cssProperty)
}